module.exports = __webpack_public_path__ + "static/img/icon_cloud_item1.e0bcc75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_item1.jpg
// module id = UFGt
// module chunks = 21